import PropTypes from 'prop-types';
import InterviewTileBadges, { InterviewTileBadgesConfigType } from './InterviewTileBadges';
import { TileDisplayConfigType } from '../../Grid2';
import { openVideoUrlInPlayer } from '../../../Gallery/VideoPlayer';
import InterviewTileFooter, { InterviewTileFooterConfigType } from './InterviewTileFooter';
import InterviewTilePreview from './InterviewTilePreview';
import { ModelInterviewType } from './InterviewTilePropTypes';
import HoverContainer from '../Base/HoverContainer';
import GuestAccess from '../../../../utils/GuestAccess';
import NeedVipOverlay from '../Base/Restrictions/NeedVipOverlay';
import InterviewTilePlayButton from './InterviewTilePlayButton';
import ReloadHelper from '../../../../utils/ReloadHelper';
import { Component } from 'react';

class InterviewTile extends Component {
	constructor(props) {
		super(props);

		this.videoContainer = null;
		this.onClick = this.onClick.bind(this);
	}

	onClick(e) {
		e.preventDefault();
		e.stopPropagation();

		const accessSettings = {
			...GuestAccess.settingsFromRestrictions(this.props.data.restriction.reasons),
			ignorePaymentFirst: true,
		};

		GuestAccess.onContentAccess(accessSettings, (successType) => {
			switch (successType) {
				case GuestAccess.SUCCESS_DIRECT:
					if (this.videoContainer) {
						openVideoUrlInPlayer(this.videoContainer, this.props.data.videoUrl, [this.props.data.previewUrl]);
					}
					break;

				default:
				case GuestAccess.SUCCESS_PAYTOUR:
					ReloadHelper.reloadCurrentPage(false);
			}
		});
	}

	render() {
		const data = this.props.data;
		const config = this.props.config;
		const displayConfig = this.props.displayConfig;

		const needsAbo = GuestAccess.needsAboAndHasAvs(data.restriction.reasons);

		return (
			<div className={'grid-2__tile__type-interview'} onClick={this.onClick}>
				<HoverContainer>
					<InterviewTilePreview previewUrl={data.previewUrl} title={data.title} blur={needsAbo} />
					{!needsAbo && <InterviewTilePlayButton />}
					{needsAbo ? <NeedVipOverlay /> : <InterviewTileBadges data={data} config={config.badges} displayConfig={displayConfig} />}
				</HoverContainer>
				{!data.restriction.restricted && <div ref={(ref) => (this.videoContainer = ref)} />}
				<InterviewTileFooter data={data} displayConfig={displayConfig} config={config.footer} />
			</div>
		);
	}
}

InterviewTile.propTypes = {
	data: ModelInterviewType.isRequired, // VXQL ModelInterview type
	config: PropTypes.shape({
		badges: InterviewTileBadgesConfigType,
		footer: InterviewTileFooterConfigType,
	}).isRequired,
	displayConfig: TileDisplayConfigType.isRequired,
};

InterviewTile.defaultProps = {
	config: {
		badges: InterviewTileBadges.defaultProps.config,
		footer: InterviewTileFooter.defaultProps.config,
	},
};

export default InterviewTile;
